<template>
  <!-- Landing -->
  <section>
    <Breadcrumbs
      :post-info="postInfo"
      :page-info="pageInfo"
    />
    <div class="row mtxl mobile-top-margin">
      <div class="large-24 columns">
        <div class="landing">
          <div class="mobile">
            <h5 v-html="owners[0].name" />
            <h2 v-html="postInfo.post_title" />
          </div>
          <a
            v-if="updateHistory"
            class=" dark-ben-franklin last-updated"
            tabindex="0"
            @keyup.enter="openUpdateModal"
            @click="openUpdateModal"
          >
            LAST UPDATED: {{ lastUpdated }}
          </a>
          <div
            class="mtm mbl post-content"
            v-html="philaLink(postInfo.post_content)"
          />
          <SearchTabs 
            :post-info="postInfo" 
            :search-this-page-disabled="true" 
          />
          <TableOfContents
            class="desktop"
            :longform-document="longformDocument"
          />
          <TableOfContentsMobileDrawer
            :longform-document="longformDocument"
            class="mobile mtl"
          />
        </div>
      </div>
    </div>
    <UpdateModal
      :post-info="postInfo"
      :update-history="updateHistory"
      :is-update-modal-open="isUpdateModalOpen"
      @closeUpdateModal="UpdateModalStatus"
    />
  </section>
  <!-- /Landing -->
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs.vue';
import SearchTabs from '@/components/SearchTabs.vue';
import TableOfContents from '@/components/TableOfContents.vue';
import TableOfContentsMobileDrawer from '@/components/TableOfContentsMobileDrawer.vue';
import UpdateModal from '@/components/UpdateModal.vue';

export default {
  name: 'Index',
  components: {
    Breadcrumbs,
    SearchTabs,
    TableOfContents,
    TableOfContentsMobileDrawer,
    UpdateModal,
  },
  props: {
    longformDocument: {
      type: Object,
      required: true,
    },
    postInfo: {
      type: Object,
      required: true,
    },
    updateHistory: {
      type: Array,
      required: true,
    },
    owners: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isUpdateModalOpen: false,
      pageInfo: 'Contents',
    };
  },
  computed: {
    lastUpdated() {
      return this.updateHistory[this.updateHistory.length - 1].phila_update_date;
    },
  },
  methods: {
    openUpdateModal() {
      let vm = this;
      vm.isUpdateModalOpen = true;
      const mq = window.matchMedia( "(max-width: 767px)" );
      vm.isFullScreen = mq.matches ? true : false;
    },
    UpdateModalStatus() {
      let vm = this;
      vm.isUpdateModalOpen = false;
    },
  },
};
</script>